import React from "react";
import { cn } from "../lib/utils";

// The two Vidyapeeth360 brand assets (in public/): the full horizontal lockup (main logo) + the square
// app icon/mark. Import these constants everywhere — never hardcode a logo/icon path.
// -nav variant: 671x132 LANCZOS downscale (43KB vs 336KB) — the logo renders at 32-44px high,
// so the 9420px master wasted ~300KB on every marketing page load (audit finding).
export const LOGO_FULL = `${process.env.PUBLIC_URL || ""}/vidyapeethNewlogo-nav.png`;
// WP-15: 386px-wide 2x downscale (scripts/generate_icon_variants.py) — 2x of the footer's 193px
// render and <=2.5x of the 163px header render, vs the 671px -nav file's ~4x waste at 32px high.
export const LOGO_FULL_2X = `${process.env.PUBLIC_URL || ""}/vidyapeethNewlogo-nav-2x.png`;
export const LOGO_ICON = `${process.env.PUBLIC_URL || ""}/vidyapeeth-icon.png`;

// Intrinsic aspect of the -nav lockup (671x132) — width/height attrs prevent layout shift.
const LOGO_FULL_RATIO = 671 / 132;

/* Brand mark — the square icon (`vidyapeeth-icon.png`) + optional "Vidyapeeth360" wordmark.
   BRAND RULE (2026-07-07): every brand-chrome surface renders the ONE full lockup — <LogoFull/>
   (`vidyapeethNewlogo` artwork) — so the logo never forks across pages. Use LogoMark ONLY where a
   horizontal lockup physically cannot fit (e.g. icon-only in a collapsed rail via showText={false});
   never as a page/nav/panel brand. */
export function LogoMark({ className, size = 32, showText = false }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img
        src={LOGO_ICON}
        alt="Vidyapeeth360"
        className="rounded-xl object-cover ring-1 ring-white/10"
        style={{ width: size, height: size }}
      />
      {showText && <LogoFull height={Math.max(22, Math.round(size * 0.9))} />}
    </div>
  );
}

/* Full horizontal brand lockup (vidyapeethLogo.png — transparent bg, mark + wordmark baked in).
   Shown as-is in every theme: the transparent PNG sits on light and dark surfaces alike. */
export function LogoFull({ className, height = 44 }) {
  // `block` removes the inline-image baseline gap (a few px of descender space below an inline <img>)
  // that otherwise pushes the logo slightly above centre inside a flex/grid `items-center` container.
  // WP-15/WP-16: explicit width/height (no layout shift), a min-height floor (never an illegible
  // shrink), and the right-sized 2x asset with the 671px file as a srcset fallback.
  const h = Math.max(28, height);
  const w = Math.round(h * LOGO_FULL_RATIO);
  return (
    <img
      src={LOGO_FULL_2X}
      srcSet={`${LOGO_FULL_2X} 386w, ${LOGO_FULL} 671w`}
      sizes={`${w}px`}
      alt="Vidyapeeth360 — Complete School Management"
      width={w}
      height={h}
      className={cn("block object-contain min-h-[28px]", className)}
      style={{ height: h }}
    />
  );
}
